export default __webpack_public_path__ + "static/media/bike_image4.bbf1f9cf.jfif";